import { render, staticRenderFns } from "./UserUpdateForm.vue?vue&type=template&id=b1015522"
import script from "./UserUpdateForm.vue?vue&type=script&lang=ts"
export * from "./UserUpdateForm.vue?vue&type=script&lang=ts"
import style0 from "./UserUpdateForm.vue?vue&type=style&index=0&id=b1015522&prod&lang=scss&scopend=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports